export default function DateChooser({className, date, onChange, offsetCount = 1, props}) {

	const goNextDate = direction => {
		let tmpDate = new Date(date);
		tmpDate.setDate(tmpDate.getDate() + direction);
		onChange?.(tmpDate.toISOString().substring(0, 10));
	}

    return <div className={'d-flex ' + className }>
                <button className="btn btn-sm btn-primary me-2" onClick={e => goNextDate(-offsetCount)}><span className='fa fa-chevron-left'></span></button>
                <input className='form-control form-control-sm' type="date" value={date} onChange={e => onChange?.(e.target.value)} />
                <button className="btn btn-sm btn-primary ms-2" onClick={e => goNextDate(offsetCount)}><span className='fa fa-chevron-right'></span></button>
            </div>
}